import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { GlobalService } from 'src/app/services/global.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate, CanActivateChild {
  private router = inject(Router);
  private globalService = inject(GlobalService);

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.resolveMaintenanceRedirect(state.url);
  }

  async canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.resolveMaintenanceRedirect(state.url);
  }

  private async resolveMaintenanceRedirect(
    targetUrl: string
  ): Promise<boolean | UrlTree> {
    if (targetUrl.startsWith('/public/maintenance')) {
      return true;
    }

    const maintenanceMode = await firstValueFrom(
      this.globalService.getMaintenanceMode()
    );

    if (!maintenanceMode) {
      return true;
    }

    return this.router.createUrlTree(['/public/maintenance']);
  }
}
